import {Component, ViewChild} from '@angular/core';
import {App, NavController, ModalController, NavParams, IonicPage, PopoverController, ViewController, Events} from 'ionic-angular'

//import {CoverageTabsView} from '../tabs/coverage'
import {CoverageService} from '../../../services/coverage.service'
import CoverageC from '../../../models/coveragec.model'

//import {SearchView} from '../search/search.view'


import { Observable } from 'rxjs/Observable';


//import {CoveragesPage} from './pages/tabs/coverage'
@Component({
  template: `
    <ion-list>
      <ion-list-header>Ionic</ion-list-header>
      <button ion-item (click)="changeFilter('aware.facebook.count')">aware</button>
      <button ion-item (click)="changeFilter('data.wp.date')">date</button>
      <button ion-item (click)="changeFilter('statut.last_update')">last_update</button>
      
    </ion-list>
  `
})
export class PopoverPage {
  constructor(public viewCtrl: ViewController, private events: Events) {}

  close() {
    this.viewCtrl.dismiss();
  }

  changeFilter(type){
      //this.orderBy = 'aware.facebook.count';

      this.events.publish('changeFilter', type);
      this.close();
  }

}

@IonicPage({
  segment: 'list',
  priority: 'off'
})
@Component({
  selector: 'coverage-list',
  templateUrl: 'coverage.list.html'
})

export class CoverageList {

  //@ViewChild('popoverContent', { read: ElementRef }) content: ElementRef;
  //@ViewChild('popoverText', { read: ElementRef }) text: ElementRef;

  coverages
  coverage
  navbarTheme

  postFilter
  searchView
  
  //posts: Post[] = []
  filteredPosts: Observable<CoverageC>;
  topCoverage: Observable<CoverageC>;
  orderBy
  _orderBy
  
  

  constructor(
    public coverageService: CoverageService,
    public params: NavParams,
    public nav: NavController,
    public app: App,
    public popoverCtrl: PopoverController, 
    private events: Events,
    public modalCtrl: ModalController,

  ) {
    //this.af = af
    
    this.postFilter = 'coverage'
    this.searchView = 'SearchView';
    this.orderBy = 'statut.last_update';
    
    //let coverage_all = params.get('coverage') || {}
    //console.log(this.coverage_all)
    //this.coverage = coverage_all.data.wp;

    //this.coverageService = coverageService;

    
    //if(this.coverage.theme) this.navbarTheme = this.coverage.theme.theme + '-1'; else this.navbarTheme = 'primary';



    //.sortBy(arr, function(o) { return o; })

    
    //this.coverageDetailView = CoverageTabsView
    //this.downloadAllCoverages()
  }

  ngOnInit() {
   
    /*this._orderBy = (data) => {
      this.orderBy = data;
    }*/
    //if(this._orderBy) this.orderBy = this._orderBy;

    //this.events.subscribe('changeFilter', this._orderBy);
    this.events.subscribe('changeFilter', (type) => {
      // user and time are the same arguments passed in `events.publish(user, time)`
      console.log('Welcome', type);
      this.orderBy = type;
      this.refreshPostSource();
    });
  }

  ionViewDidLoad() {
      this.filteredPosts = this.coverageService.collectionCoverages(this.postFilter, this.orderBy, 30);
      this.topCoverage = this.coverageService.collectionCoverages(this.postFilter, 'aware.facebook.count', 30);
      

  }

  goToCoverage(info) {
    let nav = this.app.getRootNav();
    nav.push('CoverageTabs', {coverage: info, slug: info.slug});

    //let profileModal = this.modalCtrl.create('CoverageTabs', {coverage: info, slug: info.slug});
    //profileModal.present();
  }

  
  
  refreshPostSource() {
      this.filteredPosts = this.coverageService.collectionCoverages(this.postFilter, this.orderBy, 30);
  }

  goToAware(event, coverage) {
    //this.nav.push('CoverageHome', this.data_contact);
    
    this.coverageService.set_info(coverage);  //if(this.site.menu === 2) 
    //this.categories = this.MenuService.getAware();
    
    //this.menuCtrl.close();
  }

  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(PopoverPage, {}, {cssClass: 'popover-ios'});
    popover.present({
      ev: myEvent
    });
  }

  

  all() {
    //this.coverageService.allCoverages()
    //  .then(coverages => this.coverages = coverages)
  }
}



// WEBPACK FOOTER //
// ./src/pages/coverage/list/coverage.list.ts